/**
 * Unit formatting utilities for distance and speed
 */

/**
 * Format distance with appropriate units (meters or kilometers)
 * @param {number} distanceKm - Distance in kilometers
 * @returns {string} Formatted distance string
 */
export function formatDistance(distanceKm) {
  if (distanceKm === null || distanceKm === undefined || isNaN(distanceKm)) {
    return '-- km'
  }
  
  if (distanceKm < 1.0) {
    // Convert to meters for distances less than 1km
    const meters = Math.round(distanceKm * 1000)
    // If rounding results in 1000m, show as 1.0 km instead
    if (meters >= 1000) {
      return '1.0 km'
    }
    return `${meters} m`
  } else {
    // Keep in kilometers for distances >= 1km
    return `${distanceKm.toFixed(1)} km`
  }
}

/**
 * Format checkpoint distance for table display (always in km)
 * @param {number} distanceKm - Distance in kilometers
 * @returns {string} Formatted checkpoint distance string (e.g., "km 5.2", "km 0.0")
 */
export function formatCheckpointDistance(distanceKm) {
  if (distanceKm === null || distanceKm === undefined || isNaN(distanceKm)) {
    return '--'
  }
  
  // Always show in kilometers for checkpoint table
  return `km ${distanceKm.toFixed(1)}`
}

/**
 * Format speed with appropriate units (m/min or km/h)
 * @param {number} speedKmh - Speed in km/h
 * @returns {string} Formatted speed string
 */
export function formatSpeed(speedKmh) {
  if (speedKmh === null || speedKmh === undefined || isNaN(speedKmh)) {
    return '-- km/h'
  }
  
  if (speedKmh < 1) {
    // Convert to meters per minute for very slow speeds
    const metersPerMinute = Math.round(speedKmh * 1000 / 60)
    return `${metersPerMinute} m/min`
  } else {
    // Keep in km/h for normal speeds
    return `${speedKmh.toFixed(1)} km/h`
  }
}